class GlocalFirestoreData {

    static userId = '';


    static userName = '';
    static useremail = '';
    static role = '';


}

export default GlocalFirestoreData;